/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentModelCoinsResponse } from './search-equipment-model-coins-response';


export interface SearchEquipmentModelsResponse { 
    id: string;
    name: string;
    manufacturerName: string;
    hashrate: string;
    nominalPower: number;
    coins: Array<SearchEquipmentModelCoinsResponse>;
}

